import axios from "axios";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import swal from "sweetalert";

import login from "./login.css";
const api = axios.create({
  //  baseURL: "http://localhost:8000",
  //  baseURL: "http://103.13.211.35:82",
  baseURL: "http://102.220.22.97:8000",
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    Accept: "*/*",
  },
});
const Login = (props) => {
  const [inputs, setInputs] = useState({});
  const [disabled, setDisabled] = useState(false);
  const handleSubmit = (event) => {
    event.preventDefault();
    setDisabled(true);

    let data = JSON.stringify(inputs);
    api.post("/authenticate", data).then(
      (response) => {
        setDisabled(false);
        if (response.status == "200") {
          let data = response.data;
          let user = data.user;
          window.sessionStorage.setItem("xtoken", data.token);
          window.sessionStorage.setItem(
            "SecurityGroupId",
            user.securityGroupId
          );
          window.sessionStorage.setItem("UserId", user.id);
          window.sessionStorage.setItem("Photo", user.userPhoto);
          window.sessionStorage.setItem("UserName", user.username);
          window.sessionStorage.setItem(
            "Institutionname",
            "Ministry of Tourism and Wildlife"
          );
          window.location.reload();
          return (window.location = "#/");
        } else {
          swal("", "Account not found or Invalid login details", "error");
        }
      },
      (error) => {
        setDisabled(false);
        swal("", "Login Failed", "error");
      }
    );
  };
  const handleresetpassword = (url) => {
    let data = JSON.stringify({ email: inputs.username });
    api.get(url, data).then(
      (response) => {
        let data = response.data;
        if (data.resultCode === "00") {
          swal(
            "",
            data.description + " New password sent to your email",
            "success"
          );
        } else {
          swal("", data.description, "error");
        }
      },
      (error) => {
        swal("", "Request Failed", "error");
      }
    );
  };
  const handlereset = () => {
    if (inputs.username) {
      handleresetpassword("/api/forgotPassword?userName=" + inputs.username);
    } else {
      alert("Email is required");
    }
  };
  const handleInputChange = (event) => {
    event.persist();
    setInputs((inputs) => ({
      ...inputs,
      [event.target.name]: event.target.value,
    }));
  };

  return (
    <div className="container-fluid">
      <div>
        <br />
        <div className="login login-v2">
          <div id="firstdiv">
            <p
              style={{
                "line-height": 1.5,
                "text-align": "center",
                "font-weight": "bold",
                marginBottom: "0px",
              }}
            >
              MINISTRY OF TOURISM & WILDLIFE
            </p>
            <br />
            <p
              style={{
                "line-height": 1.5,
                "text-align": "center",
                "font-weight": "bold",
                marginBottom: "0px",
              }}
            >
              National Tourism Service Portal
            </p>
            <br />

            <hr />
          </div>
          <div className="login-content">
            <form onSubmit={handleSubmit}>
              <div className="form-group m-b-15">
                <b
                  style={{
                    color: "black",
                    "font-weight": "bold",
                  }}
                >
                  Username
                </b>
                <input
                  type="text"
                  className="form-control form-control-lg"
                  name="username"
                  onChange={handleInputChange}
                  defaultValue={inputs.username}
                  required
                />
              </div>
              <div className="form-group m-b-15">
                <b
                  style={{
                    color: "black",
                    "font-weight": "bold",
                  }}
                >
                  Password
                </b>
                <input
                  type="password"
                  className="form-control form-control-lg"
                  placeholder="Password"
                  name="password"
                  onChange={handleInputChange}
                  defaultValue={inputs.password}
                  required
                />
              </div>

              <div className="login-buttons">
                <button
                  type="submit"
                  className="btn btn-success btn-block btn-lg"
                  disabled={disabled}
                >
                  Login
                </button>
              </div>

              <hr />
              <b
                style={{ cursor: "pointer" }}
                onClick={handlereset}
                className="text-black"
              >
                Forgot your Password? click here to reset now
              </b>
              <br />

              <hr />
              <p className="text-center text-grey-darker mb-0">
                &copy; Ministry of Tourism & Wildlife
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
